import {createMuiIcon} from "./createMuiIcon";


export const IssuesIcon = createMuiIcon("flag", "IssuesIcon");
